import React from 'react'
import { SliderControl } from './SliderControl'
import { TRANSFORM_RANGES } from '../../constants'
import type { TransformState } from '../../types'

interface TransformSectionProps {
  transform: TransformState
  onChange: (payload: Partial<TransformState>) => void
}

const LABELS: Record<keyof TransformState, string> = {
  x: 'X',
  y: 'Y',
  scale: 'Scale',
  rotate: 'Rotate',
  skewX: 'Skew X',
  skewY: 'Skew Y',
  opacity: 'Opacity',
}

export function TransformSection({ transform, onChange }: TransformSectionProps) {
  return (
    <div className="space-y-3">
      {(Object.keys(TRANSFORM_RANGES) as (keyof TransformState)[]).map((key) => {
        const range = TRANSFORM_RANGES[key]
        return (
          <SliderControl
            key={key}
            label={LABELS[key]}
            value={transform[key]}
            min={range.min}
            max={range.max}
            step={range.step}
            unit={range.unit}
            onChange={(val) => onChange({ [key]: val })}
          />
        )
      })}
    </div>
  )
}
